import React, { useState } from 'react';

export function AccordionItem({ title, children, open: initial = false, titleClass = 'sf__accordion-button text-lg', className = '' }) {
  const [open, setOpen] = useState(initial);
  return (
    <div className={`sf__accordion-item mb-2 overflow-hidden ${open ? 'open' : ''} ${className}`}>
      <h3 className={titleClass} onClick={() => setOpen((o) => !o)} role="button" aria-expanded={open}>
        {title}
      </h3>
      <div className="sf__accordion-content" style={{ '--content-max-height': open ? '2000px' : '0', opacity: open ? 1 : 0 }}>
        <div className="pb-5">{children}</div>
      </div>
    </div>
  );
}

export default function Accordion({ items = [] }) {
  return (
    <div className="sf__accordion">
      {items.map((it, i) => (
        <AccordionItem key={i} title={it.title} open={it.open}>
          {it.content}
        </AccordionItem>
      ))}
    </div>
  );
}
